import { BASEURLPROJETOS } from '../api/projetos'
import { payloadCadastrarProjeto, payloadCadastrarEtapa, payloadEditarEtapa } from '../../interfaces/projetos'

export function cadastrarProjeto(payload: payloadCadastrarProjeto) {
  return BASEURLPROJETOS.post('/projetos', payload)
}

export function listarProjetoPorId(idProjeto: string) {
  return BASEURLPROJETOS.get(`/projetos/${idProjeto}`)
}

export function listarMembrosProjeto(idProjeto: string) {
  return BASEURLPROJETOS.get(`/projetos/membros/${idProjeto}`)
}

export function cadastrarEtapa(payload: payloadCadastrarEtapa) {
  return BASEURLPROJETOS.post('/projetos/etapa', payload)
}

export function excluirEtapaController(idEtapa: string) {
  return BASEURLPROJETOS.patch(`/projetos/etapa/excluir/${idEtapa}`)
}

export function atualizarEtapaController(idEtapa: string, payload: payloadEditarEtapa) {
  return BASEURLPROJETOS.patch(`/projetos/etapa/${idEtapa}`, payload)
}

export function buscarEtapaController(idProjeto: string) {
  return BASEURLPROJETOS.get(`/projetos/etapa/${idProjeto}`)
}

export function deletarBacklog(idProjetoBacklog: string) {
  return BASEURLPROJETOS.delete(`/projetos/backlog/${idProjetoBacklog}`)
}

